module.exports = __webpack_public_path__ + "static/media/zhijianshebeirenyuan.3ff98463.png";